<template>
    <div :style="cssProps">
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">Drop-Off账单</h1>
                    <p class="text-white pb-3 px-3">Drop-Off账单描述</p>
                </div>
            </div>
        </base-header>
        <div class="text-center" v-if="busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow py-5">
                        <div class="col-lg-12">
                            <b-card>
                                <h2>账户余额</h2>
                                <div style="font-size: 25px;font-weight: bold;color: #FF9845">{{ amount.toFixed(2) }}
                                    ฿
                                </div>
                                <div style="display: flex;align-items: center;justify-content: flex-start;">
                                    <div style="line-height:28px;padding-right:20px;height: 28px">
                                        收款账户：{{ setUpAccountInfo.bankHolder }}
                                        {{ setUpAccountInfo.idCardNum ? setUpAccountInfo.idCardNum.replace(/^(.{6})(?:\w+)(.{4})$/, "\$1******\$2") : "" }}
                                        {{ setUpAccountInfo.email }} {{ setUpAccountInfo.bankName }}
                                        {{ setUpAccountInfo.certMobile }}
                                    </div>
                                    <b-button variant="primary" size="sm" @click="setUpAccount()">
                                        {{ setUpAccountInfo ? '修改佣金账户' : '设置佣金账户' }}
                                    </b-button>
                                </div>
                            </b-card>
                            <b-card class="mt-3">
                                <h2>提现记录</h2>
                                <div class="row">

                                    <div class="col-lg-3 m-1">
                                        <date-range-picker
                                            class="w-100"
                                            :opens="'center'"
                                            :min-date="minDate"
                                            :max-date="maxDate"
                                            :singleDatePicker="false"
                                            :appendToBody="true"
                                            :ranges="false"
                                            :closeOnEsc="false"
                                            :autoApply="true"
                                            :locale-data="{ format: 'dd-mm-yyyy' }"
                                            v-model="dataTime">
                                        </date-range-picker>
                                    </div>
                                    <div class="col-lg-2 m-1">
                                        <b-button variant="primary"
                                                @click="dropOffSettleDetailQueryList(1)">
                                            <i class="fa fa-search"></i>
                                        </b-button>
                                        <b-button variant="warning" @click="importExcel(0)">导出总账单</b-button>
                                    </div>
                                </div>
                                <b-table
                                    ref="reportDelivery"
                                    show-empty
                                    responsive
                                    :items="dataList"
                                    :fields="fields"
                                    :per-page="search.pageSize"
                                    :busy="busy"
                                    selectable
                                    select-mode="multi"
                                    class="scroll-bar-pop text-center"
                                    empty-text="暂无数据"
                                    empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                >
                                    <template slot="action" slot-scope="row">
                                        <b-button variant="warning" @click="openDetail(row.item)">详情</b-button>
                                        <b-button variant="warning" @click="importExcel(row.item)">导出</b-button>
                                    </template>
                                </b-table>

                                <div class="mt-3">
                                    <b-pagination
                                        :total-rows="totalItem"
                                        :current-page="search.pageIndex"
                                        :per-page="search.pageSize"
                                        :value="search.pageIndex"
                                        @input="changePage"
                                        align="right">
                                    </b-pagination>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dropOffBillDetail :options="detailOptions"></dropOffBillDetail>
    </div>
</template>
<script>

import {hexToRgbA} from "@/plugins/hexColor";
import {DropOffSettleDetailQueryList, exportExcelUrl, getCommissionAccount, getIncome} from "@/api/dropOff";
import moment from "moment";
import dropOffBillDetail from "@/views/newPages/DropOff/dropOffBillDetail.vue";

export default {
    name: "",
    components: {
        dropOffBillDetail
    },
    data() {
        return {
            dataTime: {
                startDate: "",
                endDate: "",
            },
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            setUpAccountInfo: {},
            busy: false,
            amount: 0,
            dataList: [],
            fields: [
                {key: 'id', label: 'ID', sortable: true},
                {key: 'createTime', label: '创建时间', sortable: true},
                {key: 'billName', label: '账单类型', sortable: true},
                {key: 'amount', label: '金额', sortable: true},
                {key: 'balance', label: '账户余额', sortable: true},
                {key: 'action', label: '操作', sortable: true},
            ],
            search: {
                pageSize: 10,
                pageIndex: 1,
            },
            totalItem: 0,
            detailOptions: {
                visible: false,
                width: '1200px',
                ids: ''
            },
        }
    },
    created() {

    },
    mounted() {
        this.getIncome()
        this.fnGetCommissionAccount()
        this.dropOffSettleDetailQueryList()
    },
    methods: {
        openDetail(row) {
            this.detailOptions.visible = true
            this.detailOptions.width = '600px'
            // this.detailOptions.id = this.multipleSelection.map(item => item.id).join(',')
            this.detailOptions.id = row.id
            this.detailOptions.billDate = row.billDate
        },
        // 导出excel
        importExcel(row) {
            console.log(row, '123123')
            if (row){
                // let ids = row.map((item) => item.id)
                exportExcelUrl({
                    exportType: 18,
                    startTime: this.dataTime.startDate ? moment(this.dataTime.startDate).format("YYYY-MM-DD") + ' 00:00:00': undefined,
                    endTime: this.dataTime.endDate ? moment(this.dataTime.endDate).format("YYYY-MM-DD") + ' 23:59:59': undefined,
                    routeName: 'Drop-OffBill',
                    dropOffBillId: row.id
                })
            }else{
                exportExcelUrl({
                    exportType: 18,
                    startTime: this.dataTime.startDate ? moment(this.dataTime.startDate).format("YYYY-MM-DD") + ' 00:00:00': undefined,
                    endTime: this.dataTime.endDate ? moment(this.dataTime.endDate).format("YYYY-MM-DD") + ' 23:59:59': undefined,
                    routeName: 'Drop-OffBill',
                }).then(res => {
                    console.log(res, 'Download')
                    window.open(res.data, '_blank')
                })
            }
        },
        dropOffSettleDetailQueryList(val) {
            if (val) {
                this.search.pageIndex = 1
            }
            this.busy = true
            DropOffSettleDetailQueryList({
                pageSize: this.search.pageSize,
                pageIndex: this.search.pageIndex,
                startTime: this.dataTime.startDate ? moment(this.dataTime.startDate).format("YYYY-MM-DD") + ' 00:00:00': undefined,
                endTime: this.dataTime.endDate ? moment(this.dataTime.endDate).format("YYYY-MM-DD") + ' 23:59:59': undefined,
                isTrusted: true
            })
                .then((res) => {
                    this.dataList = res.data.records
                    this.totalItem = res.data.total
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.busy = false
                })
        },
        changePage(i) {
            if (this.search.pageIndex == i) return;
            this.search.pageIndex = i
        },
        setUpAccount() {
            this.$router.push({
                path: '/merchantCenter',
                query: {
                    activeName: 'accountSetup'
                }
            })
        },
        // 查询佣金账户信息
        fnGetCommissionAccount() {
            getCommissionAccount()
                .then((res) => {
                    if (res.data && res.data.length === 0) {
                        this.$confirm(
                            '收款账户未设置',
                            '您尚未设置佣金收款账户，是否去设置？',
                            {
                                confirmButtonText: '去设置',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }
                        )
                            .then(() => {
                                this.setUpAccount()
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: '已取消'
                                })
                            })
                    } else {
                        this.setUpAccountInfo = res.data[0]
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        getIncome() {
            getIncome().then(res => {
                console.log(res, '123123123123')
                this.amount = res.data
            })
        }
    },
    computed: {
        cssProps() {
            return {
                '--bg-hover-color': hexToRgbA('#11cdef', 0.7),
                '--bg-color': '#11cdef',
            }
        }
    }
};
</script>
<style scoped>

</style>
